import React, { useContext } from "react";
import "./checkOut.css";
import FunnelAnalyticsTable from "./funnelAnalyticsTable";
import AnalyticsContext from "../analyticsContext";
import ContainerWithTab from "../../../reusableComponents/conatinerWithTabs/ContainerWithTab";
import FunnelChartComponent from "./funnelComponent";
import { paymentMethodSplitSchema } from "./subheaders/paymentMethodSplit/paymentMethodSplitSchema";
import AnalyticsTable from "../analyticsTable";
import PieChartComponent from "./subheaders/paymentMethodSplit/PieChartComponent";
import AnalyticsKPI from "../AnalyticsKPI";
import { CheckoutAnalyticsStates } from "./CheckoutContext";
import { avgCompletionTimeTableSchema } from "../paymentLinkAnalytics/paymentLinkTableSchemas";

function CheckOut() {
  const {
    checkoutCompletionTime,
    cardAbandonmentRate,
    averageOrderValue,
    conversionRate,
    paymentMethodSplitData,
    checkoutFunnelAnalysis,
    checkoutFunnelData,
    paymentCategoryAndAvgCompletionTime,
    trafficData,
    singleStartDate,
    startDate,
    endDate,
  } = CheckoutAnalyticsStates();

  const selectedDropdownValue = useContext(AnalyticsContext);

  return (
    <div className="checkout-analytics-root">
      <div className="kpi-conatiner">
        {[...Array(4)].map((e, i) => (
          <AnalyticsKPI
            data={
              i === 0
                ? conversionRate
                : i === 1
                ? averageOrderValue
                : i === 2
                ? cardAbandonmentRate
                : checkoutCompletionTime
            }
            showPercentageKpi={true}
            showStyling={true}
            selectedDropdownValue={selectedDropdownValue}
            kpiPage={"payment_link_analytics"}
            singleStartDate={singleStartDate}
            startDate={startDate}
            endDate={endDate}
          />
        ))}
      </div>

      <div className="checkout-analytics-content">
        <ContainerWithTab
          tabs={[
            {
              header: "Checkout Funnel Analysis",
              subHeader: "Conversion Funnel",
              tabTitle: "Funnel",
              content: (
                <FunnelChartComponent
                  checkoutFunnelAnalysis={checkoutFunnelAnalysis}
                  backgroundColor={[
                    "#0050B3",
                    "#096DD9",
                    "#1890FF",
                    "#40A9FF",
                    "#69C0FF",
                  ]}
                />
              ),
            },
            {
              header: "Checkout Funnel Analysis",
              subHeader: "Conversion Funnel",
              tabTitle: "Table",
              content: (
                <FunnelAnalyticsTable
                  checkoutFunnelAnalysis={checkoutFunnelData}
                />
              ),
            },
          ]}
        />

        <ContainerWithTab
          tabs={[
            {
              header: "Average Completion Time",
              subHeader: "By Payment Category",
              tabTitle: "Table",
              content: (
                <AnalyticsTable
                  schema={avgCompletionTimeTableSchema}
                  tableTitle="Average Completion Time"
                  data={paymentCategoryAndAvgCompletionTime}
                  default_orderBy={"averageUserDurationLocale"}
                  showLogo={true}
                />
              ),
            },
          ]}
        />

        <ContainerWithTab
          tabs={[
            {
              header: "Payment Category Split",
              subHeader: "By Transaction Value",
              tabTitle: "Pie Chart",
              content: (
                <PieChartComponent
                  chartOptions={paymentMethodSplitData?.chartOptions}
                  pieChartData={paymentMethodSplitData?.chartData}
                  data={paymentMethodSplitData?.paymentMethodSplitData}
                />
              ),
            },
            {
              header: "Payment Category Split",
              subHeader: "By Transaction Value",
              tabTitle: "Table",
              content: (
                <AnalyticsTable
                  schema={paymentMethodSplitSchema}
                  data={paymentMethodSplitData?.paymentMethodSplitTableData}
                  tableTitle="Payment Category Split"
                  default_orderBy={"value"}
                />
              ),
            },
          ]}
        />

        <ContainerWithTab
          tabs={[
            {
              header: "Traffic ",
              subHeader: "By Devices",
              tabTitle: "Traffic",
              content: (
                <PieChartComponent
                  data={trafficData?.dataPoints}
                  chartOptions={trafficData?.chartOptions}
                  pieChartData={trafficData?.chartData}
                />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}

export default CheckOut;
